import script from "./ModificarSusTrabAlumno.vue?vue&type=script&setup=true&lang=js"
export * from "./ModificarSusTrabAlumno.vue?vue&type=script&setup=true&lang=js"

import "./ModificarSusTrabAlumno.vue?vue&type=style&index=0&id=27093750&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27093750"]])

export default __exports__